import { animate, state, style, transition, trigger } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, Renderer2, input } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { FormControl } from '@angular/forms';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { Partner } from '@app/models/partner/IPartner';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { SearchService } from '@app/services/search.service';
import { debounceTime, Observable, filter, share, startWith, Subject, takeUntil, switchMap } from 'rxjs';
import { MEDIA_TOKEN } from '../../../../../../tockens';
import { NavigationExtras } from '@angular/router';
import { I18nService } from '@app/services/i18n.service';
@Component({
    selector: 'clever-reiseziel',
    templateUrl: './reiseziel.component.html',
    styleUrls: ['./reiseziel.component.scss'],
    animations: [
        trigger('zoom', [
            state('leftBottom', style({ transform: 'scale(0.3)', transformOrigin: 'left bottom', opacity: '0' })),
            state('default', style({ transform: 'scale(1)', opacity: '1' })),
            transition('* <=> default', animate('10ms cubic-bezier(0.25,1,.25,1)'))
        ])
    ],
    standalone: false
})
export class ReisezielComponent implements OnInit, OnDestroy {
    readonly mode = input<string>(undefined);
    readonly type = input<string>(undefined);
    readonly completion = input<any>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    showModal: boolean = false;
    focus: boolean = true;
    suffix: string = 'Pauschalreisen';
    media: string = 'lg';
    origin: string = 'default';
    zielText: string = 'Reiseziel oder Hotelname';

    searchObj: Observable<any>;
    mySearchControl = new FormControl();
    partner: Partner;
    ops: string = '';

    defaultdatas = [
        {
            code: '133',
            name: 'Mallorca',
            superRegion: { code: '100000', name: 'Balearen' },
            img: 'https://media.acvis.de/searchimages/mallorca.webp',
            type: 3
        },
        {
            code: '149',
            name: 'Türkische Riviera',
            img: 'https://media.acvis.de/searchimages/turkisch.webp',
            superRegion: { code: '724', name: 'Türkei' },
            type: 3
        },
        {
            code: '46',
            name: 'Kreta',
            img: 'https://media.acvis.de/searchimages/kreta.jpeg',
            superRegion: { code: '100002', name: 'Griechische Inseln' },
            type: 3
        },
        {
            code: '127',
            name: 'Fuerteventura',
            img: 'https://media.acvis.de/searchimages/fuerta.webp',
            superRegion: { code: '851', name: 'Kanaren' },
            type: 3
        },
        {
            code: '160',
            name: 'Dubai',
            img: 'https://media.acvis.de/searchimages/dubai.webp',
            superRegion: { code: '650', name: 'Vereinigte Arabische Emirate' },
            type: 3
        },
        {
            code: 'MV',
            name: 'Malediven',
            img: 'https://media.acvis.de/searchimages/malediven.webp',
            type: 4
        },
        {
            code: '',
            name: 'Egal Wohin!',
            type: -1
        }
    ];

    defaultdatasBahn = [
        {
            code: '100003',
            name: 'Deutschland Nord',
            img: 'https://media.acvis.de/topregions/100003.webp',
            type: 3
        },
        {
            code: '100006',
            name: 'Deutschland Süd',
            img: 'https://media.acvis.de/topregions/100006.webp',
            type: 3
        },
        {
            code: '100005',
            name: 'Deutschland Ost',
            img: 'https://media.acvis.de/topregions/100005.webp',
            type: 3
        },
        {
            code: '100004',
            name: 'Deutschland West',
            img: 'https://media.acvis.de/topregions/100004.webp',
            type: 3
        },
        {
            code: '572',
            name: 'Österreich',
            img: 'https://media.acvis.de/topregions/572.webp',
            type: 3
        },
        {
            code: '',
            name: 'Egal Wohin!',
            type: -1
        }
    ];

    constructor(
        protected mediaObserver: BreakpointObserver,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        protected searchService: SearchService,
        protected hotelService: HotelFiltersService,
        protected i18nService: I18nService,
        protected guardService: AuthGuardService,
        @Inject(PLATFORM_ID) protected platformId: any,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
        this.media = this.media_token;
    }

    ngOnInit(): void {
        const type = this.type();
        if (type === 'hotelonly') {
            this.suffix = 'Hotel';
        }
        if (type === 'railtravel') {
            this.suffix = 'Bahnreisen';
        }
        this.initPartner();
        this.initMedia();
        this.initFilterSub();
        this.initSearchChange();
    }

    initPartner(): void {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(partner => {
            if (partner?.partnerid?.length > 0) {
                this.partner = partner;
                for (let i = 0; i < this.partner?.agenturen?.length; i++) {
                    if (this.partner?.agenturen[i]?.aktiv) {
                        this.ops += this.partner?.agenturen[i]?.code + ',';
                    }
                }
            }
        });
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    async initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            if (filter?.pauschalreiseResult?.data?.name?.length > 0) {
                if (this.zielText !== filter.pauschalreiseResult.data.name) {
                    this.zielText = filter.pauschalreiseResult.data.name;
                }
            } else {
                this.zielText = 'Reiseziel oder Hotelname';
            }
        });
    }

    async initMedia() {
       if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.media = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.media = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.media = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.media = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.media = 'xl';
        }
        this.cdr.detectChanges();
    }

    detectPast(ev) {
        ev.stopPropagation();
        ev.preventDefault();
        this.mySearchControl.setValue(' ', { emitEvent: true, emitViewToModelChange: true });
        this.cdr.detectChanges();
        this.mySearchControl.setValue(ev.clipboardData.getData('text'), { emitEvent: true, emitViewToModelChange: true });
        this.cdr.detectChanges();
    }

    initSearchChange(): void {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );

        this.searchObj = filterShare.pipe(
            switchMap(value => this.searchService.searchEntries(
                {
                    searchValue: value,
                    language: this.i18nService.lang,
                    productType: this.type(),
                    subTypeRegion: true,
                    subTypeLocation: true,
                    subTypeGiataHotel: true,
                    subTypeTrainStation: false,
                    subTypeCountry: true,
                    tourOperatorList: this.ops,
                    limit: 30,
                    // traffics: {
                    //     searchValue: value,
                    //     productType: this.type,
                    //     subTypeRegion: true,
                    //     subTypeLocation: true,
                    //     subTypeGiataHotel: true,
                    //     subTypeTrainStation: false,
                    //     subTypeCountry: true,
                    //     tourOperatorList: this.ops,
                    //     limit: 10,
                    // },
                    // ratehawk: {
                    //     searchValue: value,
                    //     ...this.partner.ratehawk
                    // }
                }, 'completions'))
        );
    }

    openModal(ev): void {
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    openModalMobile(ev): void {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal = true;
        this.zoomin('leftBottom');
    }

    closeModal(): void {
        this.showModal = false;
        this.cdr.detectChanges();
    }

    closeModalMobile(): void {
        this.showModal = false;
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }

    zoomin(position: any): void {
        this.origin = position;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.origin = 'default';
            this.cdr.detectChanges();
        });
    }

    clearText(): void {
        this.mySearchControl.setValue('');
        this.focus = false;
        this.cdr.detectChanges();
        setTimeout(() => {
            this.focus = true;
            this.cdr.detectChanges();
        }, 50);
    }

    selectValue(item): void {
        if (item.type === -1) {
            this.zielText = 'Reiseziel oder Hotelname';
            this.showModal = false;
            this.mySearchControl.setValue('');
            this.hotelService.pauschalreiseResult(null);
        } else {
            this.zielText = item?.name;
            this.showModal = false;
            this.mySearchControl.setValue('');
            this.hotelService.pauschalreiseResult({
                type: item.type,
                data: {
                    name: item.name,
                    code: item.code
                }
            });
        }
    }

    async setSelection(item) {
        this.showModal = false;
        if (item?.link?.length > 0) {
            const link = document.createElement('a');
            link.href = item.link;
            link.setAttribute('visibility', 'hidden');
            link.click();
        } else {
            this.hotelService.onlySetRealParams(item.inputData?.realparams);
            this.hotelService.gotoUrl('');
        }
        this.cdr.detectChanges();
    }
}
